<script>
  import { Tooltip } from 'sveltestrap';
  const uuid=Math.random().toString(36).replace('0.','tip');
</script>
<slot name="thing" id="{uuid}"/>
<Tooltip target={uuid}>
  <slot name="tip"/>
</Tooltip>

